export const powerBI = {
    production: false,
    apiEndPoint: "", // api endpoint for generationg embed tokens (for app-owns-data)
    powerBIEndpoint: "https://analysis.windows.net/powerbi/api",
    groupId: "3aca0c99-4ef3-4009-b365-1d8eda36da81", // similar to workspace id
    adalConfig: {
        tenant: '5daabe65-ff53-4336-a448-2f61ecf0b059', //tenant id of your organization
        clientId: '60bf5a0c-1ec9-45a2-8ff9-485ee997c6ae', // client id of your azure ad application
        cacheLocation: 'localStorage', // Default is sessionStorage
        redirectUri:`${window.location.origin}/`,
        popUp: false    
    }
};